const { each, template } = require('lodash');

var Reverb = window.Reverb || {};

Reverb.Typeahead = (function () {
  'use strict';

  var typeahead_fn = jQuery.fn.typeahead.noConflict();
  jQuery.fn.twitterTypeahead = typeahead_fn;

  function init($input, options) {
    $input.each(function () {
      var typeaheadInput = new Reverb.Typeahead.Input($(this));
      typeaheadInput.init(options);
    });
  }

  function remove($input) {
    $input.twitterTypeahead('destroy');
  }

  function close($input) {
    $input.twitterTypeahead('close');
  }

  return {
    init: init,
    remove: remove,
    close: close
  };
})();

Reverb.Typeahead.Input = function ($input) {
  'use strict';

  var MIN_QUERY_LENGTH = 2;
  var self = this;

  self.$input = $input;

  var recentSearches = $input.data('recent-searches') || [];

  var typeaheadOptions = {
    hint: false,
    minLength: 0,
    highlight: true,
    classNames: {
      input: 'autocomplete-input',
      hint: 'autocomplete-hint',
      menu: 'autocomplete-menu',
      dataset: 'autocomplete-dataset',
      suggestion: 'autocomplete-suggestion',
      empty: 'autocomplete-empty',
      open: 'autocomplete-open',
      cursor: 'autocomplete-cursor',
      highlight: 'autocomplete-highlight',
      selectable: 'autocomplete-selectable'
    }
  };

  var searchOptions = {
    name: 'search',
    display: 'value',
    limit: 10,
    source: fetchResults,
    templates: {
      suggestion: renderSuggestion
    }
  };

  var recentSearchesOptions = {
    name: 'recentSearches',
    source: fetchRecentSearches,
    display: 'value',
    async: false,
    templates: {
      header: '<div class="autocomplete-header">' + I18n.t('js.autocomplete.recentSearches') + '</div>'
    }
  };

  var searchByShopOptions = {
    name: 'searchByShop',
    source: searchByShopSource,
    async: false,
    display: 'suggestion',
    templates: {
      suggestion: searchByShopTemplate
    }
  };

  self.init = function (options) {
    options = options || {};
    if ($input.data('ignore-find-in-shops')) {
      self.$input.twitterTypeahead(typeaheadOptions, searchOptions, recentSearchesOptions);
    } else {
      self.$input.twitterTypeahead(typeaheadOptions, searchOptions, recentSearchesOptions, searchByShopOptions);
    }

    var callback = options.suggestionSelected || suggestionSelected;
    self.$input.on('typeahead:select', function (e, suggestion) {
      callback(e, suggestion);

      if (suggestion.type !== 'query') {
        $(this).twitterTypeahead('val', '');
      }
    });
  };

  function fetchRecentSearches(query, syncResults) {
    if (query.length === 0) {
      syncResults(recentSearchSuggestions());
    }
  }

  function recentSearchSuggestions() {
    return $.map(recentSearches, function (search) {
      return new Reverb.Typeahead.Suggestion({
        value: search,
        params: { query: search },
        type: 'query',
        nested: false
      });
    });
  }

  function searchByShopSource(query, syncResults) {
    if (query.length >= MIN_QUERY_LENGTH) {
      var suggestion = new Reverb.Typeahead.ShopSearchSuggestion(query);
      syncResults([suggestion]);
    }
  }

  function searchByShopTemplate(shopSuggestion) {
    return shopSuggestion.render();
  }

  function suggestionSelected(e, suggestion) {
    window.location.href = suggestion.url;
  }

  function fetchResults(query, syncResults, asyncResults) {
    syncResults([]); // no local storage for now

    if (query.length < MIN_QUERY_LENGTH) {
      // ensure we clear out the suggestions
      asyncResults([]);
      return;
    }

    var url = self.$input.data('typeahead');
    $.get(url, { q: query }, function (data) {
      var suggestions = parseSuggestions(data);
      asyncResults(suggestions);
    });
  }

  function parseSuggestions(data) {
    var parser = new Reverb.Typeahead.SuggestionsParser(data);
    return parser.parseSuggestions();
  }

  function renderSuggestion(suggestion) {
    return suggestion.render();
  }
};

Reverb.Typeahead.SuggestionsParser = function (data) {
  'use-strict';

  var self = this;

  var alreadyExpandedFilters = false;
  var suggestions = [];

  self.parseSuggestions = function () {
    each(data, function (datum) {
      parseSuggestion(datum);

      if (!alreadyExpandedFilters) {
        parseFilters(datum);
        alreadyExpandedFilters = true;
      }
    });

    return suggestions;
  };

  function parseSuggestion(datum) {
    var suggestion = new Reverb.Typeahead.Suggestion({
      value: datum.value,
      filter: datum.filter_value,
      params: datum.params,
      type: datum.type,
      nested: false
    });
    suggestions.push(suggestion);
  }

  function parseFilters(datum) {
    each(datum.filters, function (filter) {
      var suggestion = new Reverb.Typeahead.Suggestion({
        value: datum.value,
        filter: filter.value,
        params: filter.params,
        type: datum.type,
        nested: true
      });
      suggestions.push(suggestion);
    });
  }
};

Reverb.Typeahead.Suggestion = function (data) {
  'use-strict';

  var DIGITAL_LISTING_TYPE = 'digital_listing';
  var SHOP = 'shop';
  var CURATED_SET_TYPE = 'curated_set';

  var self = this;
  self.data = data;
  self.value = data.value;
  self.params = data.params;
  self.nested = data.nested;
  self.type = data.type;
  self.filter = data.filter;
  self.url = generateUrl();

  self.render = function () {
    return template()({
      value: self.value,
      filter: self.filter,
      url: self.url
    });
  };

  function template() {
    if (self.type === 'product_type') {
      return template('<span class=\'cursor-pointer\'><span class=\'filter\'><%- value %></span></span>');
    } else if (self.type === 'curated_set') {
      return template('<span class=\'cursor-pointer\'><span class=\'curated-set\'><%- value %></span></span>');
    } else if (self.nested) {
      return template('<span class=\'cursor-pointer\'>&nbsp;&nbsp;&nbsp;&nbsp;<%- value %> in <span class=\'filter\'><%- filter %></span></span>');
    } else if (self.filter) {
      return template('<span class=\'cursor-pointer\'><%- value %> in <span class=\'filter\'><%- filter %></span></span>');
    } else {
      return template('<span class=\'cursor-pointer\'><%- value %></span>');
    }
  }

  function generateUrl() {
    if (self.type === CURATED_SET_TYPE) {
      return '/handpicked/' + self.params.curated_set;
    }

    if (self.type === DIGITAL_LISTING_TYPE) {
      return '/software/' + self.params.category_slug + '/' + self.params.brand_slug + '/' + self.params.id;
    }

    if (self.type === SHOP) {
      return '/shop/' + self.params.query.split(':')[1];
    }

    var url = '/marketplace';
    if (self.params) {
      if (self.params.product_type) {
        url += '/' + self.params.product_type;
        if (self.params.category) {
          url += '/' + self.params.category;
        }
      }
      if (self.params.query) {
        url += '?query=' + encodeURIComponent(self.params.query);
      }
    }
    return url;
  }
};

Reverb.Typeahead.ShopSearchSuggestion = function (query) {
  'use strict';

  var SUGGESTION_TEXT = 'Find shops containing ';

  var self = this;
  self.query = extractQuery(query);
  self.icon = '<div class=\'storefront-icon\'></div> ';
  self.url = generateUrl();
  self.suggestion = SUGGESTION_TEXT + '\'' + stripHTML(self.query) + '\'';

  var innerHTML = self.icon + self.suggestion;

  self.render = function () {
    return '<a class=\'autocomplete-shop-search\' href=\'' + self.url + '\'>' + innerHTML + '</a>';
  };

  function generateUrl() {
    return '/shops/search?query=' + encodeURIComponent(self.query);
  }

  function extractQuery(query) {
    var removedSuggestionText = query.replace(SUGGESTION_TEXT, '');
    var cleanQuery = removedSuggestionText.replace(/['"]+/g, '');
    return cleanQuery;
  }

  function stripHTML(query) {
    return query.replace(/<(?:.|\n)*?>/gm, '');
  }
};

$(function () {
  'use strict';

  Reverb.Typeahead.init($('input[data-module=typeahead]'));
});



// WEBPACK FOOTER //
// ./javascripts/components/legacy/typeahead.js